import { useContext } from "react";

import { AssetsAndLotsContext, IAssetsAndLotsContext } from "../contexts";

export function useAssetsAndLots() {
  return useContext<IAssetsAndLotsContext>(AssetsAndLotsContext);
}
